import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ContentVideoListItem } from "../../content.types";
import { ApiRoutesContent } from "./../../constants/enums";

export const requestGetVideos = async (
  params: GetListRequestParams
): Promise<GetListResponse<ContentVideoListItem>> => {
  return await instance.get(ApiRoutesContent.AllVideos, { params });
};
